import { render } from "./hoverEffect1.vue?vue&type=template&id=3be2c688"
import script from "./hoverEffect1.vue?vue&type=script&lang=js"
export * from "./hoverEffect1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__